module.exports = __webpack_public_path__ + "static/media/14.0f65f612.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/14.png
// module id = 1119
// module chunks = 0